<template>
  <view class="descriptions-wrap" wx:style="{{customStyle}}">
    <view class="descriptions-title" wx:if="{{title}}">{{ title }}</view>
    <view class="descriptions-main">
      <slot />
    </view>
  </view>
  <!-- 用法举例 -->
  <!-- <es-card-wrap1>
    <es-descriptions title="123">
      <es-cell
        wx:for="{{curList}}"
        wx:key="value"
        title="{{item.label}}"
        titleWidth="58px"
        custom-class="custom-cell-type1"
        border="{{false}}"
      >
        <view>第一行</view>
        <view>第二行</view>
      </es-cell>
    </es-descriptions>
  </es-card-wrap1> -->
</template>

<script>
import { createComponent } from "@mpxjs/core";
createComponent({
  props: {
    title: String,
    customStyle: null,
  },
  methods: {},
  // 组件生命周期函数-在组件布局完成后执行)
  created() {},
});
</script>

<style lang="stylus" scoped>
.descriptions-wrap {
  padding: 12px 24px;
  background: #ffffff;

  .descriptions-title {
    line-height: 22px;
    padding-bottom: 12px;
    border-bottom: 1px solid #f0f2f7;
    margin-bottom: 12px;
    font-size: 16px;
    color: #000000;
    font-weight: 700;
  }
}
</style>

<script name="json">
module.exports = {
  component: true,
};
</script>